import React, { useState, useMemo, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { TotalSalesForm } from "./TotalSalesForm";
import ErrorHandler from "./../../core/ErrorHandler";
import { DetailsModal } from "../../grid/DetailsModal";

import { LoadingSpinner } from "./../../layout/LoadingSpinner";
import Accordion from "../../Accordion";
import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import useGridDataStateResetProcessing from "shared/hooks/useGridDataStateResetProcessing";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";
import { ConstructAggregateSetting } from "./helper/ConstructAggregateSetting";
import {
  MoneyCell,
  AggregateMoneyFooterCell,
  AggregateNumberFooterCell,
  TooltipCell
} from "../../grid/Kendo/CustomKendoGridCells";
import { GridColumn } from "@progress/kendo-react-grid";
import { ZIndexContext } from "@progress/kendo-react-common";
import { useInsertServerSideExport } from "shared/hooks/useInsertServerSideExport";

import {
  DefaultColumnWidth,
  DefaultDateColumnWidth,
  DefaultBooleanOrShortWidthColumnWidth,
} from "../../grid/Kendo/KendoGridAndColumnConstants";
import { GetISODate, DateWithoutTimeAsFormattedString, DateWithoutTime } from "shared/helpers/DateHelpers";

export function TotalSalesByLocation(props) {
  const { passedProps } = props;
  const user = passedProps.user.email;
  const [error, setError] = useState({});

  const [submittedFormData, setSubmittedFormData] = useState({});

  const [showModal, setShowModal] = useState(false);

  let detailGridAggregateColumnSettings = [
    { aggregate: "sum", field: "AdjudicatedAmount" },
    { aggregate: "sum", field: "PaidAmount" },
    { aggregate: "sum", field: "CoPay" },
  ];
  const [detailGridAggregates, setDetailGridAggregates] = useState([]);


  const [mainGridColumns, setMainGridColumns] = useState([]);

  const [mainGridAggregates, setMainGridAggregates] = useState([]);
  const [detailsGridApiEndpoint, setDetailsGridApiEndpoint] = useState("");
  const [detailsGridParameters, setDetailsGridParameters] = useState({});
  const _container = React.useRef();
  const clientGridRef = useRef();
  const clientDetailGridRef = useRef();
  const sendMainAggregatesToParent = (aggregatesFromSharedTotalSalesGrid) => {
    setMainGridAggregates(aggregatesFromSharedTotalSalesGrid.data);
  };

  const sendDetailAggregatesToParent = (aggregatesFromSharedTotalSalesGrid) => {
    setDetailGridAggregates(aggregatesFromSharedTotalSalesGrid.data);
  };

  const {
    gridDataStateResetProcessingInitiated,
    InitiateGridDataStateReset,
    GridDataStateResetCompleted: onGridDataStateResetCompleted,
  } = useGridDataStateResetProcessing();

  const locationApiParams = useMemo(() => {
    if (IsNullOrEmpty(user)) {
      return {};
    }

    if (IsNullOrEmpty(submittedFormData.selectedLocation)) {
      return {};
    }

    let params = {
      toDate: DateWithoutTimeAsFormattedString(submittedFormData.toDate),
      fromDate: DateWithoutTimeAsFormattedString(submittedFormData.fromDate),
      dateType: submittedFormData.dateType,
      paidAmountType: submittedFormData.paidAmountType,
      includeCopay: submittedFormData.includeCopay,
      hideIgnored: submittedFormData.omitIgnored,
      mmids: submittedFormData.selectedLocation,
      includeClid2: submittedFormData.includeClid2,
      user: user,
    };

    return params;
  }, [submittedFormData]);

  function handleFormSubmit(e) {
    setSubmittedFormData(e);
    InitiateGridDataStateReset();
  }

  function CreateGridColumn(column) {
    let columnWidth = DefaultColumnWidth();

    if (column.title === "Pharmacy Name") {
      columnWidth = "300em";
    }

    let filterType = "text";
    if (column.type === "money" || column.type === "number") {
      filterType = "numeric";
    }
    if (column.hidden == true) {
      return;
    }

    if (column.type === "money") {
      return (
        <GridColumn
          key={column.field}
          filter={filterType}
          field={column.field}
          title={column.title}
          width={columnWidth}
          locked={column.locked}
          cells={{
            data: MainGridMoneyCell,
            footerCell: MainGridAggregateMoneyFooterCell,
          }}
          footerCell={MainGridAggregateMoneyFooterCell}
          headerCell={TooltipCell}
        />
      );
    } else if (column.type === "number") {
      return (
        <GridColumn
          key={column.field}
          filter={filterType}
          field={column.field}
          title={column.title}
          width={columnWidth}
          cells={{
            footerCell: MainGridAggregateNumberCell,
          }}
          headerCell={TooltipCell}
          footerCell={MainGridAggregateNumberCell}
        />
      );
    } else {
      return (
        <GridColumn
          key={column.field}
          filter={filterType}
          field={column.field}
          title={column.title}
          width={columnWidth}
          locked={column.locked}
          headerCell={TooltipCell}
        />
      );
    }
  }

  function getLocationDetails(props) {
    setShowModal(true);
    var parameters1 = {};

    if (props.isAggregate) {
      parameters1 = {
        nCPDP: "",
        mMIDs: props.pushMMID.toString(),
        searchStartDate: DateWithoutTimeAsFormattedString(props.startDate),
        searchEndDate: DateWithoutTimeAsFormattedString(props.endDate),
        dateType: submittedFormData.dateType,
        hideIgnored: submittedFormData.omitIgnored,
        user: user,
        paidAmountType: submittedFormData.paidAmountType,
        includeClid2: submittedFormData.includeClid2,
      }
      setDetailsGridApiEndpoint("api/TotalSales/GetByLocationAggregateDetails");
      setDetailsGridParameters(parameters1);
    }
    else {
      if (props.field == "TotalSales") {
        var startDate = submittedFormData.fromDate;
        var endDate = submittedFormData.toDate;
        parameters1 = {
          nCPDP: props.dataItem["NCPDP"],
          mMIDs: props.dataItem["MMID"],
          searchStartDate: DateWithoutTimeAsFormattedString(startDate),
          searchEndDate: DateWithoutTimeAsFormattedString(endDate),
          dateType: submittedFormData.dateType,
          hideIgnored: submittedFormData.omitIgnored,
          user: user,
          paidAmountType: submittedFormData.paidAmountType,
          includeClid2: submittedFormData.includeClid2,
        }
        setDetailsGridApiEndpoint("api/TotalSales/GetByLocationAggregateDetails");
        setDetailsGridParameters(parameters1);
      }
      else {
        parameters1 = {
          nCPDP: props.dataItem["NCPDP"],
          mMIDs: props.dataItem["MMID"],
          searchDate: props.field,
          dateType: submittedFormData.dateType,
          hideIgnored: submittedFormData.omitIgnored,
          user: user,
          paidAmountType: submittedFormData.paidAmountType,
          includeClid2: submittedFormData.includeClid2,
        }
        setDetailsGridApiEndpoint("api/TotalSales/GetByLocationDetails");
        setDetailsGridParameters(parameters1);
      }
    }
  }

  let MainGridMoneyCell = (props) => {
    let onCellClick = () => {
      let inputProps = {
        ...props,
        isAggregate: false
      };
      getLocationDetails(inputProps);
    };

    let options = {
      onClick: onCellClick,
    };

    return MoneyCell(props, options);
  };

  let DetailsGridAggregateMoneyCell = (props) => {
    var options = {
      aggregateData: detailGridAggregates,
    };
    return AggregateMoneyFooterCell(props, options);
  };
  let MainGridAggregateNumberCell = (props) => {
    var options = {
      aggregateData: mainGridAggregates,
    };
    return AggregateNumberFooterCell(props, options);
  };

  const MainGridAggregateMoneyFooterCell = (props) => {
    let onCellClick = () => {
      var startDate;
      var endDate;
      if (props.field == "TotalSales") {
        startDate = submittedFormData.fromDate;
        endDate = submittedFormData.toDate;
      } else {
        startDate = props.field;
        endDate = props.field;
      }

      const filteredDataFromComponent = clientGridRef.current
        ? clientGridRef.current.GetGridFilteredData()
        : [];

      let allFilteredMMIDs = "";
      if (filteredDataFromComponent) {
        filteredDataFromComponent.forEach((element) => {
          allFilteredMMIDs = allFilteredMMIDs + element["MMID"] + ",";
        });
      } else {
        alert("No data is displayed on grid");
        return null;
      }

      //NOTE: Restore this
      getLocationDetails({
        isAggregate: true,
        pushMMID: allFilteredMMIDs,
        startDate: DateWithoutTimeAsFormattedString(startDate),
        endDate: DateWithoutTimeAsFormattedString(endDate)
      });

    };

    var options = {
      aggregateData: mainGridAggregates,
      onClick: onCellClick,
    };
    return AggregateMoneyFooterCell(props, options);
  };

  function setMainGridData(data) {
    let columns = [];

    if (data.length > 0) {
      let headerProps = {
        PharmacyName: {
          title: "Pharmacy Name",
          truncatable: true,
          locked: true,
        },
        NCPDP: { title: "NCPDP", locked: true },
        MMID: { title: "MMID", hidden: true, locked: true },
        TotalSales: {
          title: "Total Sales",
          locked: true,
          type: "money",
          showTotal: true,
        },
      };

      Object.keys(data[0]).map((key) => {
        let countColumnTitle = "Claim Count";

        if(locationApiParams && locationApiParams.dateType === "checkDate"){
          countColumnTitle = "Payment Count";
        }

        return columns.push({
          field: key,
          title: headerProps[key]
            ? headerProps[key].title
            : key.includes("Count")
              ? countColumnTitle
              : key,
          type: headerProps[key]
            ? headerProps[key].type
            : key.includes("Count")
              ? "number"
              : "money",
          showTotal: headerProps[key] ? headerProps[key].showTotal : true,
          fixedLeft: headerProps[key] ? true : false,
          truncatable: headerProps[key] ? headerProps[key].truncatable : false,
          selectable: headerProps[key] || key.includes("Count") ? false : true,
          hidden: headerProps[key] ? headerProps[key].hidden : false,
          locked: headerProps[key] ? headerProps[key].locked : false,
        });
      });

      setError({});
    } else {
      setError({ status: 201, Message: "No data found for given parameters" });
    }

    setMainGridColumns(columns);
  }


  let { mutate: mutateForServerSideExport } = useInsertServerSideExport();

  //NOTE TODO: This is the thing to write out, review how it's being done with the Aging Details
  function detailsGridErrorHandlerCallback(error) {
    // alert("details grid error");
    //NOTE: Just look to see what parameters are being passed in from CurrentAging

    let exportRequestParameters = { ...detailsGridParameters };

    if (exportRequestParameters.searchDate) {
      exportRequestParameters.searchDate = GetISODate(exportRequestParameters.searchDate);
    }
    if (exportRequestParameters.searchStartDate) {
      exportRequestParameters.searchStartDate = GetISODate(exportRequestParameters.searchStartDate);
    }
    if (exportRequestParameters.searchEndDate) {
      exportRequestParameters.searchEndDate = GetISODate(exportRequestParameters.searchEndDate);
    }

    //NOTE TODO: Need to handle updates to searchStartDate and searchEndDate

    let apiEndpoint = "";

    if (detailsGridApiEndpoint === "api/TotalSales/GetByLocationDetails") {
      apiEndpoint = "api/TotalSales/PostTotalSalesByLocationDetailsExcelExportRequestToAzureStorage";
    }
    else if (detailsGridApiEndpoint === "api/TotalSales/GetByLocationAggregateDetails") {
      apiEndpoint = "api/TotalSales/PostTotalSalesByLocationAggregateDetailsExcelExportRequestToAzureStorage";
    }

    let mutateParameter = {
      error: error,
      endpoint: apiEndpoint,
      directParameters: exportRequestParameters
    };

    //NOTE: Okay good so the handler function only gets called once

    mutateForServerSideExport(mutateParameter);
  }

  let detailsGridUseQueryOptions = { refetchOnWindowFocus: false };

  return (
    <div className="feature-tab" id="total-sales-by-location">
      <ErrorHandler
        error={error}
        onClose={() => {
          setError({});
        }}
      />
      <Accordion defaultExpanded label="Search & Filter">
        <Row>
          <Col className="higher-zindex-filters">
            <TotalSalesForm handleFormSubmit={handleFormSubmit} _uid="TSL" />
          </Col>
          {/* <Col>
                        <FeatureWidget
                            title='Total Sales - Last 8 Days'
                            iFrameId='sisense-aging-frame'
                            filters={{}}
                            dashboard={process.env.REACT_APP_Dashboard_TotalSales}
                            widget={process.env.REACT_APP_Widget_TotalSales}
                            settings={{ showToolbar: false, showLeftPane: false, showRightPane: false }}
                            hidden={false}
                        />
                    </Col> */}
        </Row>
      </Accordion>
      <div ref={_container}>
        <ZIndexContext.Provider value={20002}>
          <Row>
            <Col className="tight-grid multi-line-filter">
              <SharedMainSelectableClientGrid
                ref={clientGridRef}
                apiGetEndpoint={"api/TotalSales/GetByLocation"}
                apiParameters={locationApiParams}
                aggregateColumnSettings={ConstructAggregateSetting(new Date(submittedFormData.fromDate), new Date(submittedFormData.toDate))}
                sendAggregatesParentCallback={sendMainAggregatesToParent}
                styleOverride={{ minHeight: "19em", maxHeight: "50em" }}
                onDataStateChangedCallback={() => {
                  const allData = clientGridRef.current
                    ? clientGridRef.current.GetAllGridData()
                    : [];
                  if (allData) {
                    setMainGridData(allData);
                  }
                }}
                gridDataStateResetProcessingInitiated={
                  gridDataStateResetProcessingInitiated
                }
                onGridDataStateResetCompleted={onGridDataStateResetCompleted}
                exportFileNamePrefix={"TotalSalesByLocation"}>

                {mainGridColumns.length > 0
                  ? mainGridColumns.map((singleColumn) =>
                    CreateGridColumn(singleColumn)
                  )
                  : null}
              </SharedMainSelectableClientGrid>
            </Col>
          </Row>
        </ZIndexContext.Provider>
      </div>
      <DetailsModal
        title="Total Sales Detail"
        show={showModal}
        handleClose={() => setShowModal(false)}
      >
        <ZIndexContext.Provider value={10003}>
          <Row>
            <Col className="tight-grid multi-line-filter">
              <SharedMainSelectableClientGrid
                ref={clientDetailGridRef}
                apiGetEndpoint={detailsGridApiEndpoint}
                apiParameters={detailsGridParameters}
                useQueryOptions={detailsGridUseQueryOptions}
                gridErrorHandlerCallback={detailsGridErrorHandlerCallback}
                aggregateColumnSettings={detailGridAggregateColumnSettings}
                sendAggregatesParentCallback={sendDetailAggregatesToParent}
                styleOverride={{ minHeight: "19em", maxHeight: "50em" }}
                exportFileNamePrefix={"TotalSalesByLocationDetails"}>
                <GridColumn
                  key={"NCPDP"}
                  field={"NCPDP"}
                  title={"NCPDP"}
                  width={DefaultBooleanOrShortWidthColumnWidth()}
                  locked={true}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"Script"}
                  field={"Script"}
                  title={"Prescription"}
                  width={DefaultBooleanOrShortWidthColumnWidth()}
                  locked={true}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"DispensedDate"}
                  field={"DispensedDate"}
                  title={"Dispensed Date"}
                  width={DefaultDateColumnWidth()}
                  filter={"date"}
                  format="{0:d}"
                  locked={true}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"TransactionDate"}
                  field={"TransactionDate"}
                  title={"Transaction Date"}
                  width={DefaultDateColumnWidth()}
                  filter={"date"}
                  format="{0:d}"
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"Payer"}
                  field={"Payer"}
                  title={"Payer Name"}
                  width={DefaultColumnWidth()}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"BIN"}
                  field={"BIN"}
                  title={"BIN"}
                  width={DefaultColumnWidth()}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"PCN"}
                  field={"PCN"}
                  title={"PCN"}
                  width={DefaultColumnWidth()}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"AdjudicatedAmount"}
                  field={"AdjudicatedAmount"}
                  width={DefaultColumnWidth()}
                  title={"Promise To Pay"}
                  filter={"numeric"}
                  cells={{
                    data: MoneyCell,
                    footerCell: locationApiParams.dateType !== "checkDate" ? DetailsGridAggregateMoneyCell : null,
                  }}
                  footerCell={locationApiParams.dateType !== "checkDate" ? DetailsGridAggregateMoneyCell : null}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"PaidAmount"}
                  field={"PaidAmount"}
                  width={DefaultColumnWidth()}
                  title={"Remittance Paid"}
                  filter={"numeric"}
                  cells={{
                    data: MoneyCell,
                    footerCell: DetailsGridAggregateMoneyCell,
                  }}
                  footerCell={DetailsGridAggregateMoneyCell}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"CoPay"}
                  field={"CoPay"}
                  title={"Co-Pay"}
                  width={DefaultColumnWidth()}
                  filter={"numeric"}
                  cells={{
                    data: MoneyCell,
                    footerCell: locationApiParams.dateType !== "checkDate" ? DetailsGridAggregateMoneyCell : null,
                  }}
                  footerCell={locationApiParams.dateType !== "checkDate" ? DetailsGridAggregateMoneyCell : null}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"NDC"}
                  field={"NDC"}
                  title={"NDC"}
                  width={DefaultColumnWidth()}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"Quantity"}
                  field={"Quantity"}
                  title={"Qty"}
                  width={DefaultColumnWidth()}
                  filter={"numeric"}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"DaysSupply"}
                  field={"DaysSupply"}
                  title={"Days Supply"}
                  width={DefaultColumnWidth()}
                  filter={"numeric"}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"AuthorizationID"}
                  field={"AuthorizationID"}
                  title={"Authorization ID"}
                  width={DefaultColumnWidth()}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"CardholderID"}
                  field={"CardholderID"}
                  title={"Cardholder ID"}
                  width={DefaultColumnWidth()}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"LastCheckNo"}
                  field={"LastCheckNo"}
                  title={"Last Received Check #"}
                  width={DefaultColumnWidth()}
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"LastCheckDate"}
                  field={"LastCheckDate"}
                  title={"Last Received Check Date"}
                  width={DefaultColumnWidth()}
                  filter={"date"}
                  format="{0:d}"
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"LastCheckPaymentDate"}
                  field={"LastCheckPaymentDate"}
                  title={"Last Received Check Payment Date"}
                  width={DefaultColumnWidth()}
                  filter={"date"}
                  format="{0:d}"
                  headerCell={TooltipCell}
                />
                <GridColumn
                  key={"ArchiveDate"}
                  field={"ArchiveDate"}
                  title={"Payment/Check Archive Date"}
                  width={DefaultColumnWidth()}
                  filter={"date"}
                  format="{0:d}"
                  headerCell={TooltipCell}
                />
              </SharedMainSelectableClientGrid>
            </Col>
          </Row>
        </ZIndexContext.Provider>
      </DetailsModal>
    </div>
  );
}
